import { ThemeOptions } from "@mui/material";
import {
  generateDefaultGJTypography,
  generateErrorWarnInfoColors,
  MuiChip,
  MuiFilledInput,
  zeroBorderRadius
} from "./util/theme-generator-util";

export const aByAdinaFontFamilyRegular = "Moderat-Regular";

export const aByAdinaThemeConfig: ThemeOptions = {
  components: {
    MuiChip,
    MuiAppBar: {
      styleOverrides: {
        root: ({ theme }) => ({
          border: "none",
          backgroundColor: `${theme.palette.background.paper} !important`,
          button: {
            color: `${theme.palette.common.black} !important`,
            svg: {
              color: `${theme.palette.common.black} !important`
            },
            span: {
              svg: {
                color: `${theme.palette.common.black} !important`
              }
            }
          },
          div: {
            button: {
              img: {
                height: "44px"
              }
            }
          },
          [theme.breakpoints.up("md")]: {
            backgroundColor: `${theme.palette.common.black} !important`,
            button: {
              color: `${theme.palette.common.white} !important`,
              span: {
                svg: {
                  color: `${theme.palette.common.white} !important`
                }
              },
              svg: {
                color: `${theme.palette.common.white} !important`
              }
            }
          }
        })
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: ({ theme }) => ({
          border: `1px solid ${theme.palette.primary.main}`,
          svg: {
            color: `${theme.palette.common.black}`
          }
        })
      }
    },
    MuiGrid: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: `${theme.palette.common.black} !important`
        })
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: ({ theme }) => ({
          "& .MuiPaper-root": {
            backgroundColor: `${theme.palette.common.white}`,
            borderColor: `${theme.palette.primary.main}`,
            borderWidth: 1,
            svg: {
              color: `${theme.palette.primary.main}`
            }
          }
        })
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: () => ({
          background: "transparent !important",
          border: "none !important"
        }),
        label: ({ theme }) => ({
          color: theme.palette.common.black
        })
      }
    },
    MuiButton: {
      variants: [
        {
          props: { variant: "primary" },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.black,
            fontWeight: 400,
            fontSize: 16,
            lineHeight: "20px",
            letterSpacing: "0.02em",
            "&:hover": {
              backgroundColor: theme.palette.primary.main,
              "@media (hover: none)": {
                backgroundColor: theme.palette.primary.main
              }
            },
            "&:disabled": {
              color: theme.palette.common.black,
              backgroundColor: theme.palette.primary.main
            }
          })
        },
        {
          props: { variant: "secondary" },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.primary.main}`,
            color: "#000000",
            fontSize: 16,
            lineHeight: "20px",
            fontWeight: 400,
            letterSpacing: "0.02em",
            "&:hover": {
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.primary.main}`,
              "@media (hover: none)": {
                border: `1px solid ${theme.palette.primary.main}`
              }
            },
            "&:disabled": {
              border: `1px solid ${theme.palette.primary.main}`
            }
          })
        }
      ],
      styleOverrides: {
        root: () => ({
          textTransform: "none",
          padding: "12px 22px",
          "&:disabled": {
            opacity: 0.4
          },
          "&:disabled&containedPrimary": {
            color: "#FFFFFF"
          },
          fontSize: "17px",
          lineHeight: "20px"
        })
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: ({ theme }) => ({
          "&::before": {
            borderBottom: `1px solid ${theme.palette.primary.main} !important`
          }
        })
      }
    },
    MuiFilledInput,
    MuiBottomNavigation: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.common.white,
          svg: {
            color: `${theme.palette.primary.main} !important`,
            path: {
              stroke: `${theme.palette.primary.main} !important`
            }
          },
          a: {
            span: {
              p: {
                fontWeight: "300",
                fontSize: "12px !important",
                lineHeight: "20px",
                letterSpacing: ".5px",
                textTransform: "uppercase"
              }
            }
          }
        })
      }
    },
    MuiDialog: {
      styleOverrides: {
        container: {
          div: {
            border: "none"
          }
        }
      }
    },
    MuiToolbar: {
      styleOverrides: {
        root: ({ theme }) => ({
          path: {
            stroke: `${theme.palette.common.black}`
          }
        })
      }
    },
    MuiTypography: {
      styleOverrides: {
        h2: ({ theme }) => ({
          fontWeight: theme.typography.fontWeightRegular,
          fontSize: theme.typography.body1.fontSize
        })
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#69696d"
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: `
        .FakeInputBox {
          border-bottom: 1px solid #CDAA8C !important;
          background: transparent !important;
          padding: 0 !important;
           > div > div > svg {
            stroke: #CDAA8C !important;
            width: 24px;
            height: 24px;
          }
        };
        .DesktopCard {
          background: #ffffff;
          margin-top: 40px;
        },
        .HeroCard {
          background: #ffffff;
        }
        .EventCardContent {
          background: #ffffff;
        }
      `
    }
  },
  shape: {
    borderRadius: zeroBorderRadius
  },
  palette: {
    primary: {
      main: "#CDAA8C"
    },
    secondary: {
      main: "#CDAA8C"
    },
    ...generateErrorWarnInfoColors(),
    background: {
      paper: "#F6F6F6",
      default: "#F6F6F6"
    },
    text: {
      secondary: "#AAAAAF",
      primary: "#1E1923"
    },
    action: {
      disabledOpacity: 0
    }
  },
  typography: generateDefaultGJTypography(aByAdinaFontFamilyRegular)
};
